import React, { createContext, useState, useEffect } from 'react';
import '../css/Styles.css';
import { useAuthProvider } from '../../providers/AuthProvider';

const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
    const { profile } = useAuthProvider();
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    useEffect(() => {
        if (!profile) return;

        const storedTheme = localStorage.getItem('theme');
        const mode = profile.dark_mode ? 'dark' : 'light';

        if (!storedTheme) {
            localStorage.setItem('theme', mode);
        }
        
        // update theme in the state if no local storage theme is found
        setTheme( storedTheme || mode );
    }, [profile]);

    const value = {
        theme,
        setTheme, // Allow children to update the theme
    };

    const containerStyle = {
        display: 'flex',
        margin: '0px',
        padding: '0px',
        width: '100%',
        height: '100%',
        backgroundColor: theme === 'dark' ? '#191a1a' : '#ffffff',
    };

    return (
        <ThemeContext.Provider value={value}>
            <div className="container-fluid" style={containerStyle}>
                {children}
            </div>
        </ThemeContext.Provider>
    );
};

const useTheme = () => {
    const context = React.useContext(ThemeContext);

    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }

    return context;
};

export { ThemeProvider, useTheme, ThemeContext };
